<template>
  <div>
    <ModalEdit
      v-if="packageItem"
      ref="modalEdit"
      :edited-package-item="packageItem"
      :product="product"
      :updating="updating"
      @submit="doUpdatePackageItem"
    />
  </div>
</template>

<script>
import { packageItemMethods, packageItemComputed } from '@/store/adminHelper';
import ModalEdit from '@/components/PackageItem/ModalEdit.vue';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import { entityComputed } from '@/store/helper';

export default {
  name: 'PackageItemEditView',
  mixins: [veeValidateErrorsMixin],
  components: {
    ModalEdit,
  },
  props: {
    packageItemId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    updating: false,
  }),
  computed: {
    ...packageItemComputed,
    ...entityComputed,
    product() {
      if (!this.packageItem) return null;
      const { productId } = this.packageItem;
      return this.entityById('products', productId);
    },
  },
  created() {
    this.setCurrent(this.packageItemId);
  },
  methods: {
    ...packageItemMethods,
    doUpdatePackageItem(updateData) {
      this.updating = true;
      const { id: packageItemId } = this.packageItem;
      this.updatePackageItem({ packageItemId, updateData })
        .then(() => {
          this.updating = false;
          this.redirectToPackageItem();
        })
        .catch(({ status = null, data = {} } = {}) => {
          if (status === HTTP_UNPROCESSABLE_ENTITY) {
            this.observer = this.$refs.modalEdit.$refs.observer;
            this.addServerErrors(data.errors);
          }
          this.updating = false;
        });
    },
    redirectToPackageItem() {
      this.$router.go(-1);
    },
  },
};
</script>
